// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalV1MedicalBiResultSearchDefaultResponseData {
    static getAttributeTypeMap() {
        return MedicalV1MedicalBiResultSearchDefaultResponseData.attributeTypeMap;
    }
}
MedicalV1MedicalBiResultSearchDefaultResponseData.discriminator = undefined;
MedicalV1MedicalBiResultSearchDefaultResponseData.additionalProperties = false;
MedicalV1MedicalBiResultSearchDefaultResponseData.attributeTypeMap = [
    {
        "name": "additionalNotes",
        "baseName": "additionalNotes",
        "type": "string"
    },
    {
        "name": "annualCap",
        "baseName": "annualCap",
        "type": "string"
    },
    {
        "name": "annualCapExist",
        "baseName": "annualCapExist",
        "type": "boolean"
    },
    {
        "name": "annualCapMetAmount",
        "baseName": "annualCapMetAmount",
        "type": "number"
    },
    {
        "name": "appeal",
        "baseName": "appeal",
        "type": "MedicalBiAppeal"
    },
    {
        "name": "benefitNetworkStatus",
        "baseName": "benefitNetworkStatus",
        "type": "string"
    },
    {
        "name": "benefitsNotes",
        "baseName": "benefitsNotes",
        "type": "string"
    },
    {
        "name": "buyAndBillAvailable",
        "baseName": "buyAndBillAvailable",
        "type": "string"
    },
    {
        "name": "claimAddress",
        "baseName": "claimAddress",
        "type": "string"
    },
    {
        "name": "cobraPlan",
        "baseName": "cobraPlan",
        "type": "MedicalBiPlan"
    },
    {
        "name": "coInsurance",
        "baseName": "coInsurance",
        "type": "string"
    },
    {
        "name": "coordinationOfBenefits",
        "baseName": "coordinationOfBenefits",
        "type": "string"
    },
    {
        "name": "copay",
        "baseName": "copay",
        "type": "MedicalBiCopay"
    },
    {
        "name": "cptCodes",
        "baseName": "cptCodes",
        "type": ""
    },
    {
        "name": "createdTimestamp",
        "baseName": "createdTimestamp",
        "type": "Date"
    },
    {
        "name": "deductibleIncludedInOop",
        "baseName": "deductibleIncludedInOop",
        "type": "boolean"
    },
    {
        "name": "denial",
        "baseName": "denial",
        "type": "MedicalBiDenial"
    },
    {
        "name": "facility",
        "baseName": "facility",
        "type": "MedicalBiFacility"
    },
    {
        "name": "family",
        "baseName": "family",
        "type": "MedicalBiFamily"
    },
    {
        "name": "followsMedicareGuidelines",
        "baseName": "followsMedicareGuidelines",
        "type": "string"
    },
    {
        "name": "healthExchangePlan",
        "baseName": "healthExchangePlan",
        "type": "MedicalBiPlan"
    },
    {
        "name": "individual",
        "baseName": "individual",
        "type": "MedicalBiIndividual"
    },
    {
        "name": "jCodes",
        "baseName": "jCodes",
        "type": ""
    },
    {
        "name": "lifetime",
        "baseName": "lifetime",
        "type": "MedicalBiLifetime"
    },
    {
        "name": "medical",
        "baseName": "medical",
        "type": "MedicalBiMedical"
    },
    {
        "name": "multipleCopay",
        "baseName": "multipleCopay",
        "type": "boolean"
    },
    {
        "name": "obtainPreDetermination",
        "baseName": "obtainPreDetermination",
        "type": "MedicalBiObtainPreDetermination"
    },
    {
        "name": "obtainPriorAuthorization",
        "baseName": "obtainPriorAuthorization",
        "type": "MedicalBiObtainPriorAuthorization"
    },
    {
        "name": "patient",
        "baseName": "patient",
        "type": "MedicalBiPatientResult"
    },
    {
        "name": "payor",
        "baseName": "payor",
        "type": "MedicalBiPayorResult"
    },
    {
        "name": "pbm",
        "baseName": "pbm",
        "type": "MedicalBiPbm"
    },
    {
        "name": "pcp",
        "baseName": "pcp",
        "type": "MedicalBiPcp"
    },
    {
        "name": "peerToPeer",
        "baseName": "peerToPeer",
        "type": "MedicalBiPeerToPeer"
    },
    {
        "name": "practice",
        "baseName": "practice",
        "type": "MedicalBiPractice"
    },
    {
        "name": "preDetermination",
        "baseName": "preDetermination",
        "type": "MedicalBiPreDetermination"
    },
    {
        "name": "preferredSpecialty",
        "baseName": "preferredSpecialty",
        "type": "MedicalBiPreferredSpecialty"
    },
    {
        "name": "prescriber",
        "baseName": "prescriber",
        "type": "MedicalBiPrescriberResult"
    },
    {
        "name": "prescription",
        "baseName": "prescription",
        "type": "MedicalBiPrescription"
    },
    {
        "name": "priorAuthorization",
        "baseName": "priorAuthorization",
        "type": "MedicalBiPriorAuthorization"
    },
    {
        "name": "reasonForNonCoverage",
        "baseName": "reasonForNonCoverage",
        "type": "string"
    },
    {
        "name": "referral",
        "baseName": "referral",
        "type": "MedicalBiReferral"
    },
    {
        "name": "reviewRequired",
        "baseName": "reviewRequired",
        "type": "boolean"
    },
    {
        "name": "specialtyPharmacy",
        "baseName": "specialtyPharmacy",
        "type": "MedicalBiSpecialtyPharmacy"
    },
    {
        "name": "spendDown",
        "baseName": "spendDown",
        "type": "MedicalBiSpendDown"
    },
    {
        "name": "stepTherapy",
        "baseName": "stepTherapy",
        "type": "MedicalBiStepTherapy"
    },
    {
        "name": "taskStatus",
        "baseName": "taskStatus",
        "type": "string"
    },
    {
        "name": "transactionCorrelationId",
        "baseName": "transactionCorrelationId",
        "type": "number"
    },
    {
        "name": "transactionDateTime",
        "baseName": "transactionDateTime",
        "type": "Date"
    },
    {
        "name": "transactionMessage",
        "baseName": "transactionMessage",
        "type": "string"
    },
    {
        "name": "updatedTimestamp",
        "baseName": "updatedTimestamp",
        "type": "Date"
    },
    {
        "name": "clientId1",
        "baseName": "clientId1",
        "type": "string"
    },
    {
        "name": "clientId2",
        "baseName": "clientId2",
        "type": "string"
    },
    {
        "name": "clientId3",
        "baseName": "clientId3",
        "type": "string"
    },
    {
        "name": "clientId4",
        "baseName": "clientId4",
        "type": "string"
    },
    {
        "name": "clientId5",
        "baseName": "clientId5",
        "type": "string"
    },
];
//# sourceMappingURL=medicalV1MedicalBiResultSearchDefaultResponseData.js.map